import React from 'react';
import PropTypes from 'prop-types';

const Portait = ({text, imgUrl}) => {
    return (
        <div style={{marginLeft:"25px"}}>
            <img width={91} height={101} src={imgUrl} alt={text}/>
            <div>{text}</div>
        </div>
    );
};

Portait.propTypes = {
    text: PropTypes.string,
    imgUrl: PropTypes.string,
};

export default Portait;